'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';

const imageUrl = '/products/curve.svg';
import logo from '@/public/logo.png';

const Hero = () => {
  return (
    <section
      id="home"
      className="relative w-full flex flex-col items-center justify-center min-h-screen "
    >
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className="absolute left-40 bottom-20 xl:block hidden z-10"
      >
        <Image
          className="rounded-3xl shadow-2xl"
          alt="curve"
          src={logo}
          priority
          width={200}
          height={200}
        />
      </motion.div>

      {/* Background Curve */}
      <div className="absolute inset-0 overflow-hidden">
        <Image
          className="object-cover w-full h-full "
          alt="curve"
          src={imageUrl}
          layout="fill"
          priority
          quality={75}
        />
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="relative z-10 text-center text-gray-700 px-6 md:px-12 lg:px-24 py-12 "
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="max-w-lg flex flex-col items-center justify-center gap-6 backdrop-blur-xl rounded-3xl p-4"
        >
          <h1 className="text-6xl font-extrabold leading-tight text-white lg:text-gray-700">
            اکسیر
          </h1>
          <h2 className="text-2xl lg:text-4xl font-semibold tracking-tight border-b-2 border-black pb-6">
            خریدی بی واسطه
          </h2>
          <p className="text-lg lg:text-xl  max-w-3xl mx-auto mt-2">
            تجربه خرید بی‌واسطه از مجموعه‌ای از بهترین محصولات، با ضمانت کیفیت و
            قیمت مناسب
          </p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
            className="mt-10 flex flex-col gap-10"
          >
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#shopping"
              className="bg-secondary hover:bg-primary-dark text-white py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out"
            >
              شروع خرید
            </motion.a>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.8 }}
              className="xl:hidden block"
            >
              <Image
                className="rounded-3xl shadow-2xl w-40"
                alt="curve"
                src={logo}
                priority
                quality={75}
              />
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
